import { render, staticRenderFns } from "./TenantDetailsDialog.vue?vue&type=template&id=1fc7faca&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TenantDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TenantDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./TenantDetailsDialog.vue?vue&type=style&index=0&id=1fc7faca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc7faca",
  null
  
)

export default component.exports